// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"card-content-module--cardTitle--14yTs","cardBigTitle":"card-content-module--cardBigTitle--1EinM"};